import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export function useStepResponses(stepId) {
  const steps = useSelector((state) => state.respuestas.steps);
  
  return useMemo(() => {
    const stepWithId = Object.values(steps).find(step => step.id === stepId);
    return stepWithId?.responses || {};
  }, [steps, stepId]);
}